<div class="admin-container">
  <div clas="side-nav">
    <admin-nav></admin-nav>
  </div>
  <div class="outlet">
    <router-outlet></router-outlet>
  </div>
</div>
